export default function handleNavBar() {
    if (!document.querySelector('.LocalNav')) {
        return;                        
    }
    const updateLovalNav = entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                document.querySelector('.LocalNav .is-active').classList.remove('is-active');
                var id = entry.target.getAttribute('id');
                if (id) {
                    document.querySelector(`[href="#${id}"]`).classList.add('is-active');
                }
            }
        });
    };

    const localNavObserver = new IntersectionObserver(updateLovalNav, {
        root: null,
        rootMargin: '0% 0% -80% 0%',
        threshold: 0
    });

    let sections = [...document.querySelectorAll('main > section, main > .Hero')].filter(section => {
        return section.hasAttribute('id');
    });

    sections.forEach((target, index) => {
        document.querySelectorAll('.LocalNav a')[index].setAttribute('href', '#' + target.id);
        localNavObserver.observe(target);
    });
}
